import React, { useContext } from 'react'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { Tooltip } from 'react-tooltip'
import { useNavigate } from 'react-router-dom'
import Avatar from '../Avatar/Avatar'
import { TibiContext } from '../../context/ContextProvider'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface DashboardHeaderProps {
    openSidebarNav: boolean
    setOpenSidebarNav: (value: boolean) => void
}

const DashboardHeader: React.FunctionComponent<DashboardHeaderProps> = ({
    openSidebarNav,
    setOpenSidebarNav
}: DashboardHeaderProps) => {
    //Auth hook for components
    const { signOut } = useAuthenticator()
    const { value, remove }: any = useContext(TibiContext)
    const user = value?.user

    const navigate = useNavigate()
    const { brand } = useContext(TibiContext)
    return (
        <header className='bg-transparent top-0 z-30'>
            <div className='flex flex-wrap items-center justify-between px-4 py-3 mx-auto xl:container'>
                <div className='flex items-center'>
                    <button
                        type='button'
                        className='mr-4 lg:hidden text-[--tb-mainHeading] hover:text-[--tb-primary]'
                        onClick={() => setOpenSidebarNav(!openSidebarNav)}
                    >
                        <DynamicFaIcon iconName='bars' />
                    </button>

                    {/* Logo */}
                    <button
                        type='button'
                        onClick={(e) => {
                            e.preventDefault()
                            navigate('/dashboard')
                        }}
                    >
                        <img
                            className='h-[45px] object-cover logo'
                            src={brand?.logo?.default}
                            alt={brand?.organisation}
                        />
                    </button>
                </div>

                <div>
                    <button id='userDropdown' className='space-x-2 flex items-center cursor-pointer'>
                        {/* User */}
                        <Avatar name={user?.name} />
                        <span className='capitalize font-semibold text-[--tb-text]'>{user?.name}</span>
                        <DynamicFaIcon iconName='angle-down' className='textLightColor text-opacity-75' />
                    </button>
                    <Tooltip
                        anchorSelect='#userDropdown'
                        variant='light'
                        clickable
                        className='bg-white p-0 m-0 rounded-lg shadow-lg bg-opacity-100'
                    >
                        <button
                            onClick={async () => {
                                await signOut()
                                remove()
                                navigate('/login')
                            }}
                            className=' text-[--tb-text] px-4 py-2 font-semibold cursor-pointer hover:text-[--tb-mainHeading]'
                        >
                            Uitloggen
                        </button>
                    </Tooltip>
                </div>
            </div>
        </header>
    )
}

export default DashboardHeader
